import React from "react";
import logoNew from "../../assets/img/logoNew.png";

import logoNewBright from "../../assets/img/logoNewBright.png";
import "./SignupContainer.css";
import LoginToggle from "./LoginToggle";

function SignupContainer(props) {
  return (
    <div className="row registration-root-flexbox">
      <div className="col-lg-6 auth-left mobile-background-registration registration-left-section">
        <div className="auth-form signup-container-inner">
          {/* large screen */}
          <div className="small-screen-disappear registration-title">
            <h1 className="text-center">{props.heading}</h1>
            <h1 className="text-center">{props.subheading}</h1>
          </div>

          {/* small screen */}
          <div className="auth-text-top small-screen-appear d-none">
            <img src={logoNew} alt="logo" className="signup-mobile-logo" />
            <h1 className="text-center mx-0">{props.heading}</h1>
            {props.subheading && <h1 className="text-center">{props.subheading}</h1>}
          </div>
          {props.toggle}
          {props.google}
          <form
            className="signup-form mt-4"
            id="form-register"
            onSubmit={props.onSubmit}
          >
            {props.children}
          </form>
        </div>
      </div>

      <div className="col-lg-6 auth-right d-lg-flex d-none bg-photoregister registration-right-section">
        <div className="bg-gradient"></div>
        <div className="logo-container">
          <img src={logoNewBright} alt="logo" className="logo logo_right" />
        </div>
        <div className="shape registration-background"></div>
      </div>
    </div>
  );
}

export default SignupContainer;
